import React from "react"
import { useTranslation } from "react-i18next"
import { dateService } from "services/date"

import { BIKE_STATUS_IN_SALE, BIKE_STATUS_SOLD, BIKE_STATUS_STOLEN } from "utils/constants"
import { BikePageProps } from "../../models"
import { LostStatusCard, RefundStatusCard, SellStatusCard } from "./Partials"

import "./BikeStatus.scoped.scss"
import { DestroyStatusCard } from "./Partials/DestroyStatusCard/DestroyStatusCard"

export const BikeStatus: React.FC<BikePageProps> = ({ bike, refreshBike }) => {
	const { t } = useTranslation()

	// There are 2 ways to have a bike "in sale"
	const isBikeInSale = bike.bike_status === BIKE_STATUS_IN_SALE
	const isBikeCurrentlyInTransit = bike.bike_status === BIKE_STATUS_SOLD && bike.bike_in_transit

	const isBikeSold = bike.bike_status === BIKE_STATUS_SOLD && !bike.bike_in_transit
	const isBikeStolen = bike.bike_status === BIKE_STATUS_STOLEN

	const isBikeActionNeeded = bike?.bike_action_needed

	return (
		<div className="c-block px-4 pt-6 mt-8 mb-12">
			<div className="c-block__title">{t("bike_state.title", { ns: "bike" })}</div>
			<div className="c-block__intro">{t("bike_state.introduction", { ns: "bike" })}</div>

			{isBikeActionNeeded && (
				<p className="c-block__intro c-block__intro--alert mt-2 py-2">
					{t("bike_state.prevent_state_modifying", {
						ns: "bike",
					})}
				</p>
			)}

			<div className="flex flex-wrap px-3 pt-5">
				{/* Active status : BIKE_STATUS_STOLEN */}
				{isBikeStolen && (
					<>
						<div className="w-full lg:w-1/2 xl:w-1/4">
							<div className="c-status-card is-active p-5 bg-secondary mx-3 mb-6">
								<div className="text-m font-bold mb-4">
									{t("bike_state.lost_status_active", {
										ns: "bike",
									})}
								</div>
								{bike.operator_data?.stolen_date && (
									<p>
										{t("bike_state.since", {
											ns: "bike",
										})}{" "}
										:&nbsp;
										{dateService.formatDate(
											bike.operator_data?.stolen_date,
											"dd.MM.yyyy"
										)}
									</p>
								)}
							</div>
						</div>

						<RefundStatusCard bike={bike} refreshBike={refreshBike} />
					</>
				)}

				{/* Active status : BIKE_STATUS_SOLD */}
				{isBikeSold && (
					<div className="w-full lg:w-1/2 xl:w-1/4">
						<div className="c-status-card is-active p-5 bg-primary mx-3 mb-6">
							<div className="text-m font-bold mb-4">
								{t("bike_state.sold_status", {
									ns: "bike",
								})}
							</div>
							<p>
								{t("bike_state.its_okay", {
									ns: "bike",
								})}
							</p>
						</div>
					</div>
				)}

				{/* Active status : BIKE_STATUS_SOLD && in transit */}
				{isBikeCurrentlyInTransit && (
					<div className="w-full lg:w-1/2 xl:w-1/4">
						<div className="c-status-card is-active p-5 bg-insaleBike mx-3 mb-6">
							<div className="text-m font-bold mb-4">
								{t("bike_state.intransit_status_active", {
									ns: "bike",
								})}
							</div>
							<p>
								{t("bike_state.intransit_status_active_description", {
									ns: "bike",
								})}
							</p>
						</div>
					</div>
				)}

				{/* Active status : BIKE_STATUS_IN_SALE */}
				{isBikeInSale && (
					<div className="w-full lg:w-1/2 xl:w-1/4">
						<div className="c-status-card is-active p-5 bg-insaleBike mx-3 mb-6">
							<div className="text-m font-bold mb-4">
								{t("bike_state.sell_status_active", {
									ns: "bike",
								})}
							</div>
							<p className="text-xxs">
								{t("bike_state.sell_status_active_description", {
									ns: "bike",
								})}
							</p>
						</div>
					</div>
				)}

				{bike.bike_status !== BIKE_STATUS_STOLEN && (
					<LostStatusCard
						bike={bike}
						refreshBike={refreshBike}
						isDisabled={
							isBikeStolen ||
							isBikeCurrentlyInTransit ||
							isBikeInSale ||
							isBikeActionNeeded
						}
					/>
				)}

				<SellStatusCard
					bike={bike}
					refreshBike={refreshBike}
					isDisabled={isBikeStolen || isBikeActionNeeded}
				/>

				<DestroyStatusCard bike={bike} />

				{/* <BackStoreStatusCard
					bike={bike}
					refreshBike={refreshBike}
					isDisabled={isBikeStolen || isBikeCurrentlyInTransit || isBikeInSale}
				/> */}
			</div>
		</div>
	)
}
